module.exports = __webpack_public_path__ + "static/media/5.46b5f35a.jpg";